import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';

// The public profile routes (publicapi.PublicPersonController); no login. Both answer the one 404 for
// an unknown, hidden or never-public person.

// {personId, mergedInto, name, shortName, photoUrl, titleLine, motivation, bio, links, bodies, appearances}
export const fetchProfile = (personId, language) => axios
  .get(`${API}/api/public/people/${encodeURIComponent(personId)}`, { params: { lang: language } })
  .then((r) => r.data);

// {austrian, top, new}: the public study feed (confirmed co-authored studies first).
export const fetchStudies = (personId, language) => axios
  .get(`${API}/api/public/people/${encodeURIComponent(personId)}/studies`, { params: { lang: language } })
  .then((r) => r.data);
